import * as React from 'preact/compat'
import Modal from '../Modal'
import type { CommentModel } from './CommentTypes'
import Api from '../../api'
import { captureFetchException, loadStylesheet, showModal } from '../../common/helpers'
import formCss from '../../../css/form.pcss.json'
import buttonsCss from '../../../css/buttons.pcss.json'
import commonCss from '../../../css/common.pcss.json'
import { useEffect } from 'preact/compat'
import { showToast } from '../toast'
import UserModerationDialog from "../user-moderation/Dialog";

interface PropTypes {
  onClose: () => void,
  comment: CommentModel,
  deleteComment: (comment: number, reason: string, deletedByModer: boolean, normalDeletion: boolean) => void
}

export default ({
  comment,
  deleteComment,
  onClose
}: PropTypes) => {
  // Component did mount
  useEffect(() => {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
  }, [])

  const [checked, setChecked] = React.useState(false)
  const [warn_user, setWarnUser] = React.useState(false)

  const onSubmit = React.useCallback((e: React.TargetedEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    Api.post({ url: 'comments/delete', body: formData })
      .then(result => {
        showToast({
          type: result.status !== 1 ? 'error' : 'success',
          text: result.message,
        })

        if (result.status === 1) {
          deleteComment(result.comment.comment_id, formData.get('reason') as string, true, formData.get('normal_deletion') === 'on')
          onClose()
          if (warn_user) {
            showModal(UserModerationDialog, {
              userId: comment.user_id
            })
          }
        }
      })
      .catch(error => {
        captureFetchException(error)
        showToast({
          type: 'error',
          text: 'При удалении комментария произошла непредвиденная ошибка, попробуй позже',
        })
        onClose()
      })
  }, [deleteComment, onClose, warn_user])

  const handleCheckboxChange = (e: React.TargetedEvent<HTMLInputElement>) => {
    setChecked(e.currentTarget.checked)
  }

  const handleWarnUserChange = (e: React.TargetedEvent<HTMLInputElement>) => {
    setWarnUser(e.currentTarget.checked)
  }

  return <Modal onClose={onClose} showClose>
    <form className={formCss['form-aligned']} onSubmit={onSubmit}>
      <input type='hidden' name='id' value={comment.comment_id}/>
      <h2 className={commonCss['h2']}>Подтверждение удаления комментария</h2>
      <styled-checkbox
        name='normal_deletion'
        label='Удалить бесследно (также удалит всю ветку)'
        checked={checked}
        value='on'
        onChange={handleCheckboxChange}
      />
      <styled-checkbox
        name='warn_user'
        label='Выдать замечание автору'
        checked={warn_user}
        value='on'
        onChange={handleWarnUserChange}
      />
      {!checked &&
        <div className={formCss['form-group--new']}>
          <label className={formCss['label']}>Причина</label>
          <textarea
            className={formCss['input']} name="reason" placeholder="Введи причину удаления (опционально)"
            defaultValue="Комментарий удалён модератором"
          />
          <span className={formCss['hint']}>Этот текст будет выведен вместо комментария</span>
        </div>
      }
      <div style='display: flex; justify-content: end; align-items: center; column-gap: 16px'>
        <button type='button' className={buttonsCss['red']} onClick={onClose}>Отмена</button>
        <button type='submit' className={buttonsCss['primary']}>Удалить</button>
      </div>
    </form>
  </Modal>
}
